import { Text } from 'components/typography'
import styled from 'styled-components'
import { HeaderHeightPx } from './header'

const Container = styled.div`
  width: 100%;
  padding: 50px 0 ${HeaderHeightPx};
`

const NoData = () => {
  return (
    <Container>
      <Text size="md" align="center">
        データがありません
      </Text>
    </Container>
  )
}

export default NoData
